import { Directive, Input, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

@Directive({
  selector: 'mat-paginator[itemLabel]',
  standalone: false,
})
export class PaginatorLabelDirective implements OnInit {
  @Input() itemLabel = 'Items';

  constructor(private paginator: MatPaginator) {}

  ngOnInit() {
    const intl = this.paginator._intl;
    intl.itemsPerPageLabel = 'Page Size:';
    intl.getRangeLabel = (page, pageSize, length) => {
      if (length === 0) {
        return `0 Total ${this.itemLabel}`;
      }
      const start = page * pageSize + 1;
      const end = Math.min((page + 1) * pageSize, length);
      return `${start} - ${end} of ${length} Total ${this.itemLabel}`;
    };
    intl.changes.next(); // trigger re-render
  }
}
